import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CaseItemFormRemoveCancelComponent} from '../../../case-forms/case-item-form-remove-cancel/case-item-form-remove-cancel.component';
import {DataARLedgerModel} from '../../../../models/accountsReceivable/data-ar-ledger.model';
import {Globals} from '../../../../globals';
import {CurrencyPipe} from '@angular/common';
import {ARService} from '../../ar.service';
import {DataARPaymentDistribsModel} from '../../../../models/accountsReceivable/data-ar-payment-distribs.model';

@Component({
  standalone: false,
  selector: 'app-ar-payment-cancel',
  templateUrl: './ar-payment-cancel.component.html',
  styleUrls: ['./ar-payment-cancel.component.css']
})
export class ArPaymentCancelComponent implements OnInit {

  isLoading: boolean = false;
  enumLedgerItemTypeCredit: string = '00000078-1000-0000-0000-000000000001';
  isPatientTransaction: boolean = true;

  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';

  constructor(
    private arService: ARService,
    public globals: Globals,
    public dialogRef: MatDialogRef<CaseItemFormRemoveCancelComponent>,
    public currencyPipe: CurrencyPipe,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

  createLedgerItemCredit() {
    const promise = new Promise((resolve, reject) => {

      // create credit for approved payment amount
      const ledgerItem = new DataARLedgerModel();
      ledgerItem.LOCID = parseInt(localStorage.getItem('LOCID'));
      ledgerItem.PatientId = this.globals.currentPatientId;
      ledgerItem.PostDate = new Date();
      ledgerItem.Amount = this.data.paymentAmount;
      ledgerItem.Description = 'Undistributed payment of ' + this.currencyPipe.transform(this.data.paymentAmount, 'USD');
      ledgerItem.Reference = '';
      ledgerItem.enumARLedgerItemTypeID = this.enumLedgerItemTypeCredit;

      if (this.isPatientTransaction) {
        ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypePatient;
      }
      else {
        ledgerItem.enumARLedgerItemOriginTypeID = this.enumARLedgerItemOriginTypeTransaction; // or maybe insurance???
      }

      // zoli said to leave this null
      // ledgerItem.enumLedgerItemStatusID

      this.arService.saveLedgerItem(ledgerItem)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createPaymentDistribution(ledgerID: string) {
    const promise = new Promise((resolve, reject) => {

      // create credit for approved payment amount
      const paymentDist = new DataARPaymentDistribsModel();
      paymentDist.Amount = this.data.paymentAmount;
      paymentDist.PaymetnID = this.data.arPaymentID;
      paymentDist.LedgerID = ledgerID;

      this.arService.CreatePaymentDistribution(paymentDist)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createCredit() {

    this.isLoading = true;

    this.createLedgerItemCredit().then((newLedgerItem: DataARLedgerModel) => {
      if (newLedgerItem) {

        // use newly created ledgeritemid to create a payment distribution record
        this.createPaymentDistribution(newLedgerItem.LedgerID).then((newPaymentDistrib: DataARPaymentDistribsModel) => {
          if (newPaymentDistrib) {

            // ledger item and payment distribution added
            // close window
            this.dialogRef.close(true);
          }
        }, err => {
          // reject(err);
        });
      }
    }, err => {
      // reject(err);
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }

}
